<template>
  <div class="flex w-[321px] min-w-[321px] flex-col max-xl:hidden">
    <div class="sticky top-[114px] flex max-h-[calc(100dvh-140px)] flex-col overflow-hidden rounded-[20px] bg-white p-4">
      <div class="flex shrink-0 items-start justify-between gap-3">
        <div>
          <h2 class="text-xl font-bold leading-[1.05] text-txmain">Корзина</h2>
          <ClientOnly>
            <p class="mt-2 text-sm leading-normal text-txmain/60">
              {{ basket.length ? `Добавлено: ${channelsCount} ${pluralize(channelsCount, ["канал", "канала", "каналов"])}` : "Пока пусто" }}
            </p>
            <template #fallback><p class="mt-2 text-sm leading-normal text-txmain/60">Пока пусто</p></template>
          </ClientOnly>
        </div>
        <ClientOnly>
          <button
            v-if="basket.length > 0"
            type="button"
            class="text-sm leading-5 text-txmain/60 transition-colors hover:text-txred"
            @click="draftId && draftId !== 0 ? (dialogDeleteLastPlace = true) : clearBasket()"
          >
            Очистить
          </button>
        </ClientOnly>
      </div>

      <ClientOnly>
        <div v-if="basket.length > 0" class="mt-4 flex min-h-0 flex-1 flex-col">
          <div class="-mr-2 flex-1 overflow-y-auto pr-2">
            <div class="space-y-3">
              <div
                v-for="group in groupedBasket"
                :key="group.id"
                class="rounded-2xl bg-bgnew p-3"
              >
                <div class="flex items-start justify-between gap-2">
                  <p class="line-clamp-2 flex-1 text-base leading-normal text-primary">
                    {{ group.name }}
                  </p>
                  <button
                    type="button"
                    class="shrink-0"
                    title="Убрать канал"
                    @click="
                      basket.length === group.items.length && draftId && draftId !== 0
                        ? (dialogDeleteLastPlace = true)
                        : removeChannel(group.id)
                    "
                  >
                    <ITrash class="size-4 fill-txsecondary transition-colors hover:fill-txred" />
                  </button>
                </div>

                <div class="mt-3 space-y-3">
                  <div
                    v-for="(item, idx) in group.items"
                    :key="`${group.id}-${item.format?.priceType}-${idx}`"
                  >
                    <div class="text-sm leading-5 text-txmain/60">{{ item.format?.name }}</div>
                    <div class="mt-1 flex items-center justify-between gap-3">
                      <p class="text-base font-medium leading-normal text-txmain">
                        {{ item.format?.price.toLocaleString() }} ₽
                      </p>
                      <div class="flex h-8 w-[97px] items-center justify-between rounded-lg bg-white px-2">
                        <button type="button" class="flex items-center" @click="decreaseQuantity(item)">
                          <IMinus class="size-4 fill-primary" />
                        </button>
                        <span class="text-sm text-txmain">{{ item.quantity || 1 }}</span>
                        <button type="button" class="flex items-center" @click="increaseQuantity(item)">
                          <IPlus class="size-4 fill-primary" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="shrink-0 pt-3">
            <div class="flex h-[50px] items-center justify-between rounded-2xl bg-bgnew px-3">
              <span class="text-sm text-txmain">Итого</span>
              <span class="text-xl font-medium leading-[1.05] text-txmain">{{ total.toLocaleString() }} ₽</span>
            </div>
            <button
              type="button"
              class="mt-3 flex w-full items-center justify-center rounded-2xl bg-primary py-5 text-base text-white transition-opacity hover:opacity-90"
              @click="goToOrder"
            >
              Оформить заказ
            </button>
          </div>
        </div>
        <div
          v-else
          class="mt-4 flex h-[300px] shrink-0 items-center justify-center rounded-2xl bg-bgnew"
        >
          <img src="/public/assets/img/svg/busket_empty_2.svg" alt="" />
        </div>
        <template #fallback>
          <div class="mt-4 flex h-[300px] shrink-0 items-center justify-center rounded-2xl bg-bgnew">
            <img src="/public/assets/img/svg/busket_empty_2.svg" alt="" />
          </div>
        </template>
      </ClientOnly>
    </div>
  </div>

  <ClientOnly>
    <Teleport to="body">
    <el-dialog v-model="dialogDeleteLastPlace" width="450" align-center class="wrapper-dialog">
      <div class="p-8">
        <div class="flex justify-center">
          <div class="bg-bgnew rounded-2xl p-5">
            <ITrash class="size-10 fill-[#F8465B]" />
          </div>
        </div>
        <h1 class="text-txmain text-[28px] font-bold text-center mt-8">Удалить черновик?</h1>
        <p class="text-txsecondary text-base text-center mt-2">
          Удаление всех каналов приведет к удалению черновика безвозвратно
        </p>
        <div class="grid grid-cols-2 gap-3 mt-8">
          <button
            class="rounded-xl py-3.5 w-full bg-[#F8465B] text-base text-white hover:bg-[#F8465B]/90 active:bg-[#F8465B]/80"
            @click="deleteDraft"
          >
            Удалить
          </button>
          <button
            class="rounded-xl py-3.5 w-full bg-bgnew text-base text-txmain hover:bg-bgnew/90 active:bg-bgnew/80"
            @click="
              () => {
                dialogDeleteLastPlace = false;
                pendingRemovalItem = null;
              }
            "
          >
            Отмена
          </button>
        </div>
      </div>
    </el-dialog>
  </Teleport>
  </ClientOnly>
</template>

<script setup lang="ts">
  import type { ReducedPlace, Place, PlacePrice } from "@/interfaces/publisher";
  import ITrash from "~/components/UINew/icons/ITrash.vue";
  import IPlus from "~/components/UINew/icons/IPlus.vue";
  import IMinus from "~/components/UINew/icons/IMinus.vue";
  import { useBasketStore } from "~/store/BasketModule";
  import OrderService from "~/services/OrderService";
  import { pluralize } from "~/common/functions";

  const basketStore = useBasketStore();
  const { basket, draftId } = storeToRefs(basketStore);

  const dialogDeleteLastPlace = ref<boolean>(false);
  const cartContainer = ref<HTMLElement>();
  const pendingRemovalItem = ref<ReducedPlace | null>(null);

  // Группируем товары по каналам
  const groupedBasket = computed(() => {
    const groups: Array<{ 
      id: number; 
      name: string; 
      items: ReducedPlace[] 
    }> = [];
    const seenChannels = new Set<number>();
    
    basket.value.forEach((item: ReducedPlace) => {
      if (!seenChannels.has(item.id)) {
        // Первое появление этого канала - добавляем новую группу
        groups.push({
          id: item.id,
          name: item.name,
          items: [item]
        });
        seenChannels.add(item.id);
      } else {
        // Канал уже есть - добавляем элемент в существующую группу
        const existingGroup = groups.find(group => group.id === item.id);
        if (existingGroup) {
          existingGroup.items.push(item);
        }
      }
    });
    
    return groups;
  });

  const channelsCount = computed(() => groupedBasket.value.length);
  const total = computed(() =>
    basket.value.reduce((acc, place) => acc + (place.format?.price || 0) * (place.quantity || 1), 0)
  );

  const clearBasket = () => {
    basket.value = [];
    // Полная очистка корзины = новый заказ → сбрасываем весь локальный черновик
    // (название, креатив, расписание, orderId), иначе данные предыдущего заказа
    // подставятся в новый.
    basketStore.campaignName = "";
    if (import.meta.client) {
      localStorage.removeItem("orderId");
      localStorage.setItem("basketType", "0");
      localStorage.removeItem("multiScheduleState");
      localStorage.removeItem("orderScheduleStateV2");
      localStorage.removeItem("scheduleId");
      localStorage.removeItem("scheduleIds");
      localStorage.removeItem("campaignName");
      localStorage.removeItem("post");
      localStorage.removeItem("creativeId");
      localStorage.removeItem("creativeUuid");
      localStorage.removeItem("creativeTemporaryToken");
      localStorage.removeItem("creativeFiles");
      // Сентинел: на следующем mount шага «Пост» проигнорировать любые остатки креатива.
      localStorage.setItem("postCleared", "1");
    }
  };

  const deleteDraft = async () => {
    try {
      // Сначала удаляем элемент из корзины если он был в ожидании
      if (pendingRemovalItem.value) {
        const index = basket.value.findIndex(
          (p: ReducedPlace) =>
            p.id === pendingRemovalItem.value!.id && 
            p.format?.priceType === pendingRemovalItem.value!.format?.priceType && 
            p === pendingRemovalItem.value
        );
        if (index !== -1) {
          basket.value.splice(index, 1);
        }
        pendingRemovalItem.value = null;
      }
      
      // Затем удаляем черновик на сервере только если он существует
      if (draftId.value && draftId.value !== 0) {
        await OrderService.deleteOrder(draftId.value.toString());
      }
      
      clearBasket();
      basketStore.setDraftStatus(false);
      basketStore.setDraftId(0);
      dialogDeleteLastPlace.value = false;
    } catch (error: any) {
      ElMessage.error(error.message || "Произошла ошибка при удалении черновика");
    }
  };

  // Удаление всего канала (всех форматов)
  const removeChannel = (channelId: number) => {
    basket.value = basket.value.filter((p: ReducedPlace) => p.id !== channelId);
    if (basket.value.length === 0 && draftId.value && draftId.value !== 0) {
      dialogDeleteLastPlace.value = true;
    }
  };

  const removePlace = (place: Place) => {
    basket.value = basket.value.filter(
      (p: ReducedPlace) => !(
        p.id === place.id && 
        ((p.format?.priceType === place.format?.priceType) || (!p.format && !place.format))
      )
    );
    if (basket.value.length === 0 && draftId.value && draftId.value !== 0) {
      dialogDeleteLastPlace.value = true;
    }
  };

  const deletePlace = async (place: any) => {
    if (!basket.value) return;
    if (place.publicationId) {
      await OrderService.removePlaceFromOrder(place.publicationId);
    }
    basket.value = basket.value.filter(
      (p: ReducedPlace) => !(
        p.id === place.id && 
        ((p.format?.priceType === place.format?.priceType) || (!p.format && !place.format))
      )
    );
  };

  const decreaseQuantity = (item: ReducedPlace) => {
    if (item.quantity && item.quantity > 1) {
      item.quantity--;
    } else {
      // Проверяем, останется ли корзина пустой после удаления И есть ли черновик
      if (basket.value.length === 1 && draftId.value && draftId.value !== 0) {
        // Сохраняем элемент для удаления после подтверждения
        pendingRemovalItem.value = item;
        dialogDeleteLastPlace.value = true;
        return;
      }
      
      // Удаляем этот конкретный формат
      const index = basket.value.findIndex(
        (p: ReducedPlace) => 
          p.id === item.id && 
          p.format?.priceType === item.format?.priceType &&
          p === item
      );
      if (index !== -1) {
        basket.value.splice(index, 1);
      }
    }
  };

  const increaseQuantity = (item: ReducedPlace) => {
    if (item.quantity && item.quantity < 10) {
      item.quantity++;
    }
  };

  const goToOrder = () => {
    const firstItemWithCreative: any = basket.value.find((p: any) => p.creativeId);
    navigateTo({
      path: "/order",
      query: firstItemWithCreative?.creativeId
        ? {
            e: firstItemWithCreative.creativeId,
          }
        : {},
    });
  };
</script>
